import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';

import { QueryClientProvider } from '@tanstack/react-query';
import { CatchBoundary, RouterProvider } from '@tanstack/react-router';

import { Composer, Error } from '@src/components/utils';
import { AuthenticationProvider, ThemeProvider } from '@src/context';
import { useAuthentication } from '@src/context/hooks';
import { Devtools } from '@src/corelib/devtools';
import { queryClient } from '@src/corelib/query';
import router from '@src/router';

import './styles/global.css';


// ActiveOrg + Permissions providers mount inside the /app shell (they derive
// from the mine/me queries), so the root stack only carries the app-wide
// theme, auth and query providers.
const PROVIDERS = [
  { element: ThemeProvider, props: {} },
  { element: AuthenticationProvider, props: {} },
  { element: QueryClientProvider, props: { client: queryClient } },
];

function InnerApp() {
  const auth = useAuthentication();
  return <RouterProvider router={router} context={{ auth }} />;
}

function App() {
  // The outermost boundary catches catastrophic errors that unmount the
  // providers + router, so its fallback MUST be context-free: ErrorState uses
  // no auth/router hooks. The rich, auth-aware SystemState lives on the router
  // __root errorComponent (ErrorBoundaryState), which renders inside the
  // providers where useAuthentication() and <Link> are available.
  return (
    <CatchBoundary getResetKey={() => 'reset'} errorComponent={Error}>
      <Composer providers={PROVIDERS}>
        <InnerApp />
        <Devtools router={router} />
      </Composer>
    </CatchBoundary>
  );
}

export default App;
